<template>
  <div class="home-page">
    <!-- 用户信息面板 -->
    <UserInfoPanel />
    <!-- 查询表单区域 -->
    <QuerySection />
    <view class="home-compand">
      <!-- 只切换这部分 -->
      <LogisticsInfo v-if="currentTab === 1" @selectLogistics="handleSelectLogistics" />
      <FactoryInfo v-else-if="currentTab === 6" @selectLogistics="handleSelectLogistics" />
      <FreightInfo v-else-if="currentTab === 4" @selectLogistics="handleSelectLogistics" />
      <!-- 其它内容不变 -->
      <view>
        <LogisticsNews />
        <DeliveryGuarantee />
      </view>
    </view>
    <CooperateShop />
    <CommonUsetool />
    <!-- <bottomView /> -->
  </div>
</template>

<script setup>
import { ref } from 'vue'
import UserInfoPanel from './components/UserInfoPanel.vue'
import QuerySection from './components/QuerySection.vue'
import LogisticsInfo from './components/LogisticsInfo.vue'
import FreightInfo from './components/FreightInfo.vue'
import FactoryInfo from './components/FactoryInfo.vue'
import LogisticsNews from './components/LogisticsNews.vue'
import DeliveryGuarantee from './components/DeliveryGuarantee.vue'
import CooperateShop from './components/CooperateShop.vue'
import CommonUsetool from './components/CommonUsetool.vue'
import { ZltContainer, DesciptionItem } from '@/components/ZltCard';
  // import bottomView from './components/bottomView.vue';

const currentTab = ref(1)
function handleSelectLogistics(id) {
  currentTab.value = id
}
</script>

<style scoped lang="scss">
  .home-page {
    font-family: Arial, sans-serif;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .home-compand {
    display: flex;
  }
</style>
